export default "__VITE_ASSET__B6nTYb7t__"